import { render, staticRenderFns } from "./BaseRichTextEditor.vue?vue&type=template&id=31c1cef5"
import script from "./BaseRichTextEditor.vue?vue&type=script&lang=js"
export * from "./BaseRichTextEditor.vue?vue&type=script&lang=js"
import style0 from "./BaseRichTextEditor.vue?vue&type=style&index=0&id=31c1cef5&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports